<template>
  <main>
    <b-container fluid class="p-0">
      <b-modal v-if="exibirModal" size="xl" id="visualizar" style="width: 70%">
        <embed :src="local_link" width="100%" height="400px" />

        <template v-slot:modal-footer="{ hide }">
          <b-button size="sm" variant="outline-danger" @click="hide()">
            Fechar
          </b-button>
        </template>
      </b-modal>

      <!-- Modal de progresso de upload -->
      <b-modal
        v-model="showUploadProgress"
        title="Enviando arquivos..."
        @hidden="onUploadModalHidden"
      >
        <div class="text-center">
          <b-progress
            :value="uploadProgress"
            variant="primary"
            striped
            animated
            class="mb-3"
          ></b-progress>
          <p>{{ uploadStatusText }}</p>
          <small class="text-muted">{{ uploadProgressFiles }}</small>
        </div>
        <template v-slot:modal-footer="{ hide }">
          <b-button size="sm" variant="secondary" @click="hide()">
            Fechar
          </b-button>
        </template>
      </b-modal>

      <div>
        <b-form @click="handleClick($event)" @submit.prevent="submit($event)">
          <h3 class="font-weight-bold">
            <router-link to="/processos/minha-unidade">
              <b-icon
                icon="arrow-left"
                style="cursor: pointer; color: #003e5d"
              />
            </router-link>
            Criar Novo Processo
          </h3>
          <hr class="pb-3" />
          <b-row>
            <div class="col-12 mb-3">
              <label class="font-weight-bolder" style="color: #003e5d"
                >Título do Processo *</label
              >
              <b-form-input
                :disabled="isLoading || isUploading"
                v-model="processo.titulo"
                class="form-control"
                required
                placeholder="Digite o nome do processo..."
              ></b-form-input>
            </div>
            <div class="col-12 col-sm-4 mb-3">
              <b-form-group
                label="Eixo:"
                class="font-weight-bolder"
                required
                style="color: #003e5d"
              >
                <b-form-select
                  v-model="eixo"
                  :disabled="isLoading || isUploading"
                  :options="eixos"
                  @change="getSubEixo($event)"
                >
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-12 col-sm-4">
              <b-form-group
                label="SubEixo:"
                class="font-weight-bolder"
                style="color: #003e5d"
                required
              >
                <b-form-select
                  v-model="subeixo"
                  :disabled="isLoading || !eixo || isUploading"
                  :options="subeixos"
                  @change="setItensChecklist()"
                ></b-form-select>
              </b-form-group>
            </div>
          </b-row>
          <div>
            <label class="font-weight-bolder" style="color: #003e5d"
              >Descrição do Processo *</label
            >
            <b-form-textarea
              v-model="processo.descricao"
              class="form-control"
              cols="30"
              rows="10"
              :disabled="isLoading || isUploading"
              required
            ></b-form-textarea>
          </div>
          <div class="card mt-3 p-3" v-if="exibeChecklist()">
            <h5 class="mb-4">{{ this.subeixo.checklist.descricao }}</h5>

            <div v-if="this.topicos.length > 0">
              <b-row v-for="topic in this.topicos" :key="topic.id" class="mt-2">
                <b-row class="col-12 mb-2 no-gutters">
                  <b-col lg="10">
                    <h6>{{ topic.titulo }}</h6>
                  </b-col>
                </b-row>

                <b-col class="col-12">
                  <div class="table-responsive">
                    <b-table
                      :busy="isLoading"
                      show-empty
                      empty-text="Nenhum item cadastrado para o tópico!"
                      striped
                      fixed
                      hover
                      :fields="[
                        'descricao',
                        { key: 'actions', label: 'Ações' },
                      ]"
                      :items="topic.itens_checklist"
                      caption-top
                    >
                      <template #cell(actions)="data">
                        <td>
                          <label
                            v-b-tooltip.hover
                            title="Carregar Anexo"
                            class="btn btn-default btn-file"
                          >
                            <b-icon
                              icon="file-earmark-plus"
                              v-if="!itemTemUpload(data.item)"
                              variant="dark"
                            ></b-icon>
                            <b-icon
                              icon="file-check"
                              v-else-if="getFileStatus(data.item) === 'completed'"
                              variant="success"
                            ></b-icon>
                            <b-spinner
                              v-else-if="getFileStatus(data.item) === 'uploading'"
                              small
                              variant="primary"
                            ></b-spinner>
                            <b-icon
                              icon="exclamation-triangle"
                              v-else-if="getFileStatus(data.item) === 'error'"
                              variant="danger"
                            ></b-icon>
                            <input
                              type="file"
                              accept=".pdf"
                              v-if="!itemTemUpload(data.item) && !isUploading"
                              @change="handleFileUpload(data.item, $event)"
                              style="display: none"
                              :disabled="isUploading"
                            />
                          </label>
                        </td>
                        <td>
                          <label
                            v-b-tooltip.hover
                            v-if="itemTemUpload(data.item) && getFileStatus(data.item) === 'completed'"
                            title="Visualizar Anexo"
                            class="btn btn-default btn-file"
                            v-b-modal.visualizar
                            @click="showFile(data.item)"
                            style="cursor: pointer"
                          >
                            <b-icon icon="eye"></b-icon>
                          </label>
                        </td>
                        <td>
                          <template v-if="getFileStatus(data.item) === 'completed'">
                            <b-icon
                              v-b-tooltip.hover
                              title="Anexo Carregado"
                              class="btn btn-default"
                              icon="check-square-fill"
                              variant="success"
                            ></b-icon>
                          </template>
                          <template v-else-if="getFileStatus(data.item) === 'uploading'">
                            <small class="text-muted">
                              {{ getFileProgress(data.item) }}%
                            </small>
                          </template>
                        </td>
                        <td>
                          <label
                            v-b-tooltip.hover
                            v-if="itemTemUpload(data.item) && !isUploading"
                            title="Excluir Anexo"
                            class="btn btn-default btn-file"
                            @click="removeFile(data.item)"
                            style="cursor: pointer"
                          >
                            <b-icon icon="trash-fill" variant="danger"></b-icon>
                          </label>
                        </td>
                      </template>
                      <template #table-colgroup="scope">
                        <col
                          v-for="field in scope.fields"
                          :key="field.key"
                          :style="{
                            width: field.key === 'actions' ? '30%' : '70%',
                          }"
                        />
                      </template>
                    </b-table>
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-row class="col-12 mb-2" v-else>
              <b-col lg="10">
                <h6>Não existem tópicos para o checklist atual!</h6>
              </b-col>
            </b-row>
          </div>
          <!--  FIM TABELA CHECKLIST-->
          <div style="text-align: right">
            <b-button
              type="submit"
              class="mt-3 mr-3"
              :disabled="isLoading || isUploading"
              @click="cancelarProcesso()"
              variant="danger"
              >Cancelar
            </b-button>
            <b-button
              name="enviar"
              type="submit"
              class="mt-3"
              variant="primary"
              :disabled="isLoading || isUploading || !allFilesUploaded()"
              >{{ isUploading ? 'Enviando arquivos...' : 'Enviar' }}
            </b-button>
          </div>
        </b-form>
      </div>
    </b-container>
  </main>
</template>

<script>
export default {
  data() {
    return {
      exibirModal: false,
      isLoading: false,
      isUploading: false,
      showUploadProgress: false,
      uploadProgress: 0,
      uploadStatusText: '',
      uploadProgressFiles: '',
      userClosedUploadModal: false,
      local_link: '',
      files: [],
      uploadSessions: {},
      eixo: null,
      eixos: [],
      subeixo: null,
      subeixos: [],
      processo: {},
      topicos: [],
      botaoClicado: '',
      // ====== AJUSTES DE CHUNK/TIMEOUT ======
      CHUNK_SIZE: 10 * 1024 * 1024, // 10MB (antes: 1MB)
      MAX_RETRY: 6, // backoff exponencial por chunk
      // ======================================
    };
  },
  methods: {
    async getEixos() {
      this.isLoading = true;
      this.eixos = [{ value: null, text: 'Selecione um eixo...' }];
      this.subeixos = [{ value: null, text: 'Selecione um subeixo...' }];
      try {
        const res = await this.$http.get('eixos', {});
        res.data.forEach(eixo => {
          this.eixos.push({ value: eixo, text: eixo.descricao });
        });
      } catch (error) {
        console.log(error.response);
      } finally {
        this.isLoading = false;
      }
    },
    getSubEixo(event) {
      if (!this.eixo) {
        this.subeixos = [{ value: null, text: 'Selecione um subeixo...' }];
        this.subeixo = null;
        return;
      }
      this.subeixo = null;
      this.files = [];
      this.uploadSessions = {};
      this.subeixos = [{ value: null, text: 'Selecione um subeixo...' }];
      event.subeixos.forEach(subeixo => {
        this.subeixos.push({ value: subeixo, text: subeixo.descricao });
      });
    },
    setItensChecklist() {
      if (this.subeixo && this.subeixo.checklist) {
        this.files = [];
        this.uploadSessions = {};
        this.topicos = [];
        this.topicos = this.subeixo.checklist.topicos;
      }
    },
    exibeChecklist() {
      return this.subeixo && !!this.subeixo.checklist;
    },

    // ====== AJUSTES RELACIONADOS AO UPLOAD ======
    sleep(ms) { return new Promise(r => setTimeout(r, ms)); },
    // ============================================

    async handleFileUpload(item, event) {
      const input = event.target;
      const file = input?.files?.[0];
      if (!file) return;

      // Adicionar arquivo à lista com status inicial
      const fileObj = {
        item_id: item.id,
        file: file,
        local_link: URL.createObjectURL(file),
        status: 'pending',
        upload_token: null,
        progress: 0,
      };

      this.files.push(fileObj);

      // Iniciar upload por chunks
      await this.startChunkedUpload(fileObj);

      // Limpar o input
      input.value = '';
    },

    async startChunkedUpload(fileObj) {
      try {
        this.isUploading = true;
        this.userClosedUploadModal = false;
        fileObj.status = 'uploading';

        const totalChunks = Math.ceil(fileObj.file.size / this.CHUNK_SIZE);

        // 1. Inicializar upload
        const initResponse = await this.$http.post('uploads/init', {
          original_name: fileObj.file.name,
          file_size: fileObj.file.size,
          total_chunks: totalChunks,
          metadata: {
            item_checklist_id: fileObj.item_id,
            tipo_anexo_id: 3 // TipoAnexo::ITEM_CHECKLIST
          }
        });

        fileObj.upload_token = initResponse.data.upload_token;
        this.uploadSessions[fileObj.upload_token] = fileObj;

        // 2. Upload dos chunks (com retry/backoff e timeout)
        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
          const start = chunkIndex * this.CHUNK_SIZE;
          const end = Math.min(start + this.CHUNK_SIZE, fileObj.file.size);
          const chunk = fileObj.file.slice(start, end);

          const formData = new FormData();
          formData.append('upload_token', fileObj.upload_token);
          formData.append('chunk_index', chunkIndex);
          formData.append('chunk', chunk, `${fileObj.file.name}.part${chunkIndex}`);

          let attempt = 0;
          // eslint-disable-next-line no-constant-condition
          while (true) {
            try {
              const cfg = {
                timeout: 60000, // 60s por chunk
                headers: { 'Content-Type': 'application/octet-stream' },
              };

              const chunkResponse = await this.$http.post('uploads/chunk', formData, cfg);

              // Atualizar progresso
              fileObj.progress = chunkResponse.data.progress ?? ((chunkIndex + 1) / totalChunks) * 100;
              this.updateGlobalProgress();

              break;


            } catch (err) {
              const status = err?.response?.status;
              const retryAfter = Number(err?.response?.headers?.['retry-after'] || 0);

              // Tenta novamente para 429/503 com backoff exponencial (respeitando Retry-After)
              if ((status === 429 || status === 503) && attempt < this.MAX_RETRY) {
                attempt++;
                const wait = retryAfter ? retryAfter * 1000 : Math.min(10000, 500 * 2 ** attempt);
                await this.sleep(wait);
                continue;
              }

              // Outros erros: propaga
              throw err;
            }

          }

          // micro pausa para aliviar limites por segundo
          await this.sleep(10);
        }

        // 3. Finalizar upload
        const completeResponse = await this.$http.post('uploads/complete', {
          upload_token: fileObj.upload_token
        });

        fileObj.status = 'completed';
        fileObj.progress = 100;

      } catch (error) {
        console.error('Erro no upload:', error);
        fileObj.status = 'error';
        this.$swal({
          title: 'Erro no upload',
          text: 'Ocorreu um erro ao enviar o arquivo. Tente novamente.',
          icon: 'error',
        });
      } finally {
        this.updateGlobalProgress();
        
        // Verificar se todos os uploads terminaram
        const stillUploading = this.files.some(f => f.status === 'uploading');
        if (!stillUploading) {
          this.isUploading = false;
          this.showUploadProgress = false;
        }
      }
    },
    // ====== FIM DOS AJUSTES DE UPLOAD ======

    onUploadModalHidden() {
      this.userClosedUploadModal = true;
    },

    updateGlobalProgress() {
      const totalFiles = this.files.length;
      if (totalFiles === 0) return;

      const completedFiles = this.files.filter(f => f.status === 'completed').length;
      const uploadingFiles = this.files.filter(f => f.status === 'uploading');

      let totalProgress = (completedFiles * 100);
      uploadingFiles.forEach(f => totalProgress += f.progress);

      this.uploadProgress = Math.round(totalProgress / totalFiles);

      this.uploadProgressFiles = `${completedFiles} de ${totalFiles} arquivos enviados`;

      if (this.isUploading && !this.showUploadProgress && !this.userClosedUploadModal) {
        this.showUploadProgress = true;
      }

      if (uploadingFiles.length > 0) {
        this.uploadStatusText = `Enviando ${uploadingFiles.length} arquivo(s)...`;
      } else if (completedFiles === totalFiles && totalFiles > 0) {
        this.uploadStatusText = 'Todos os arquivos foram enviados com sucesso!';
      }
    },

    async removeFile(item) {
      const index = this.files.findIndex(file => item.id === file.item_id);

      if (index !== -1) {
        const removedFile = this.files[index];

        try {
          // Chamar API para deletar o upload no backend se tiver token
          if (removedFile.upload_token && removedFile.status === 'completed') {
            await this.$http.delete(`uploads/${removedFile.upload_token}`);
          }

          // Limpar upload session se existir
          if (removedFile.upload_token && this.uploadSessions[removedFile.upload_token]) {
            delete this.uploadSessions[removedFile.upload_token];
          }

          this.files.splice(index, 1);

          this.$swal({
            title: 'O anexo deste item foi removido com sucesso',
            icon: 'success',
          });
        } catch (error) {
          console.error('Erro ao remover arquivo:', error);
          this.$swal({
            title: 'Erro ao remover arquivo',
            text: 'Ocorreu um erro ao remover o arquivo. Tente novamente.',
            icon: 'error',
          });
        }
      }
    },

    showFile(item) {
      try {
        this.exibirModal = true;
        let file = this.files.find(el => el.item_id == item.id);
        this.local_link = file.local_link;
      } catch (e) {
        this.local_link = '';
        this.exibirModal = false;
        this.$swal({ title: 'Não há anexo para este item', icon: 'error' });
      }
    },

    itemTemUpload(item) {
      try {
        let file = this.files.find(el => el.item_id == item.id);
        return file !== undefined;
      } catch (e) {
        return false;
      }
    },

    getFileStatus(item) {
      const file = this.files.find(el => el.item_id == item.id);
      return file ? file.status : null;
    },

    getFileProgress(item) {
      const file = this.files.find(el => el.item_id == item.id);
      return file ? Math.round(file.progress) : 0;
    },

    allFilesUploaded() {
      if (this.files.length === 0) return true;
      return this.files.every(file => file.status === 'completed');
    },

    handleClick(event) {
      this.botaoClicado = event.target.name;
    },

    async submit() {
      // Verificar se todos os itens têm arquivos
      let somaTotal = 0;
      for (let i = 0; i < this.topicos.length; i++) {
        const itensChecklist = this.topicos[i].itens_checklist;
        somaTotal += itensChecklist.length;
      }

      const completedFiles = this.files.filter(f => f.status === 'completed');

      if (completedFiles.length !== somaTotal) {
        this.$swal({ 
          title: 'Carregue todos os anexos!', 
          text: `${completedFiles.length} de ${somaTotal} arquivos carregados.`,
          icon: 'error' 
        });
        return;
      }

      // Preparar dados do processo
      const processoData = {
        prefeitura_id: localStorage.getItem('prefeitura_id'),
        status: 'Salvo',
        user_id: localStorage.getItem('user_id'),
        eixo_id: this.eixo.id,
        subeixo_id: this.subeixo.id,
        titulo: this.processo.titulo,
        descricao: this.processo.descricao,
        tem_capa: 0,
        upload_tokens: completedFiles.map(f => f.upload_token)
      };

      this.salvarProcesso(processoData);
    },

    async enviarProcesso() {
      this.processo.status = 'Encaminhado';
      this.isLoading = true;
      try {
        await this.$http.put(
          `processos/${this.processo.id}`,
          this.processo,
          {}
        );
        this.$swal({
          title: 'Processo enviado com sucesso!',
          icon: 'success',
        });
        this.$router.push('/processos/minha-unidade');
      } catch (error) {
        this.$swal({
          title: 'Ocorreu um erro ao enviar o processo!',
          icon: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },

    async salvarProcesso(processoData) {
      this.isLoading = true;
      try {
        const { data } = await this.$http.post('processos', processoData);
        if (this.botaoClicado === 'enviar') {
          this.processo = data;
          await this.enviarProcesso();
          this.limparDados();
        } else {
          this.$swal({
            title: 'Processo salvo com sucesso!',
            icon: 'success',
          });
          this.$router.push('/processos/minha-unidade');
        }
      } catch (error) {
        console.error('Erro ao salvar processo:', error);
        this.$swal({
          title: 'Ocorreu um erro ao salvar o processo!',
          icon: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },

    cancelarProcesso() {
      this.limparDados();
      this.$swal({ title: 'Cancelado!', icon: 'error' });
      this.$router.push('/processos/minha-unidade');
    },

    limparDados() {
      this.exibirModal = false;
      this.local_link = '';
      this.files = [];
      this.uploadSessions = {};
      this.eixo = {};
      this.eixos = [];
      this.subeixo = {};
      this.subeixos = [];
      this.processo = {};
      this.topicos = [];
      this.totalFileSize = 0;
      this.isUploading = false;
      this.showUploadProgress = false;
    },
  },
  created() {
    this.getEixos();
  },
};
</script>
